/**
 * Spanish locale for messaging-ui.
 * Export is the "messaging" subtree for host i18n merge.
 */
import type { MessagingLocale } from './en'

export const messagingEs = {
  list: {
    loading: `Cargando grupos de mensajes...`,
    error: `Error`,
    empty: `No se encontraron grupos de mensajes`,
    emptyDescription: `No hay grupos de mensajes configurados para esta central.`,
    deleteConfirmTitle: `Eliminar grupo de mensajes`,
    deleteConfirm: `¿Está seguro de que desea eliminar "{{name}}"?`,
    smsEnabled: `Activado`,
    smsDisabled: `Desactivado`,
    delete: `Eliminar`,
    columnGroupName: `Nombre del grupo`,
    columnPrimarySms: `SMS principal`,
    columnMembers: `Miembros`,
    columnSmsStatus: `Estado SMS`,
    columnCreated: `Creado`,
    columnUpdated: `Actualizado`,
    columnActions: `Acciones`,
    toast: {
      createdTitle: `Grupo de mensajes creado`,
      createdDescription: `"{{name}}" se ha creado correctamente.`,
      createFailedTitle: `Error al crear`,
      createFailedDescription: `No se pudo crear el grupo de mensajes`,
      deletedTitle: `Grupo de mensajes eliminado`,
      deletedDescription: `"{{name}}" ha sido eliminado.`,
      deleteFailedTitle: `Error al eliminar`,
      deleteFailedDescription: `No se pudo eliminar el grupo de mensajes`,
    },
    title: `Mensajería`,
    createButton: `+ Crear grupo`,
    searchPlaceholder: `Buscar por nombre o número de teléfono...`,
    noResults: `Sin resultados`,
    noResultsDescription: `No hay grupos de mensajes que coincidan con "{{search}}".`,
    noMembersWarning: `Este grupo no tiene miembros. Los mensajes de los clientes podrían no ser leídos.`,
  },
  detail: {
    validationErrorTitle: `Error de validación`,
    validationErrorDescription: `El nombre del grupo es obligatorio`,
    toast: {
      updatedTitle: `Grupo de mensajes actualizado`,
      updateFailedTitle: `Error al actualizar`,
      updateFailedDescription: `No se pudo actualizar el grupo de mensajes`,
      smsAddedTitle: `Número SMS añadido`,
      smsAddFailedTitle: `Error al añadir número SMS`,
      smsRemovedTitle: `Número SMS eliminado`,
      smsRemoveFailedTitle: `Error al eliminar número SMS`,
      memberAddedTitle: `Miembro añadido`,
      memberAddFailedTitle: `Error al añadir miembro`,
      memberAddFailedDescription: `No se pudo añadir el miembro al grupo`,
      memberRemovedTitle: `Miembro eliminado`,
      memberRemoveFailedTitle: `Error al eliminar miembro`,
    },
    loading: `Cargando grupo de mensajes...`,
    error: `Error`,
    notFound: `Grupo de mensajes no encontrado.`,
    title: `Editar grupo de mensajes`,
    viewTitle: `Grupo de mensajes`,
    groupNameLabel: `Nombre del grupo`,
    groupNamePlaceholder: `Introduzca el nombre del grupo`,
    primarySmsLabel: `Número SMS principal`,
    primarySmsPlaceholder: `Seleccione el número SMS principal`,
    campaignIdWarning: `El número seleccionado no tiene ID de campaña y puede no poder enviar SMS, a menos que sea un servicio de número gratuito o un número canadiense.`,
    associatedSmsLabel: `Números SMS secundarios`,
    noCampaignId: `(Sin ID de campaña)`,
    removeSmsAria: `Eliminar número SMS`,
    addSmsNumberAria: `Añadir número SMS`,
    unsavedChanges: `Cambios sin guardar`,
    campaignSummaryTitle: `{{count}} número(s) sin ID de campaña`,
    campaignSummaryDescription: `Estos números pueden no poder enviar SMS a menos que sean de servicio gratuito o números canadienses.`,
    backToList: `← Volver a la lista`,
    updating: `Actualizando...`,
    updateButton: `Actualizar grupo de mensajes`,
    noMembersWarning: `Este grupo no tiene miembros. Los mensajes de los clientes podrían no ser leídos.`,
  },
  createModal: {
    validationErrorTitle: `Error de validación`,
    validationErrorDescription: `Introduzca un nombre para el grupo de mensajes`,
    title: `Crear grupo de mensajes`,
    nameLabel: `Nombre del grupo`,
    namePlaceholder: `Introduzca el nombre del grupo`,
    primarySmsLabel: `Número SMS principal`,
    primarySmsPlaceholder: `Seleccione un número`,
    primarySmsRequired: `Seleccione un número SMS principal`,
    cancel: `Cancelar`,
    creating: `Creando...`,
    createButton: `Crear grupo`,
  },
  members: {
    groupMembersTitle: `Miembros del grupo`,
    emptyGroup: `Aún no hay miembros en este grupo.`,
    columnName: `Nombre`,
    columnExtension: `Extensión`,
    columnAdded: `Añadido`,
    availableMembersTitle: `Miembros disponibles`,
    emptyAvailable: `No hay miembros disponibles para añadir.`,
    removeMemberAria: `Eliminar miembro`,
    addMemberAria: `Añadir miembro`,
    searchPlaceholder: `Buscar por nombre o extensión...`,
    noSearchResults: `Ningún miembro coincide con su búsqueda.`,
  },
  smsModal: {
    validationErrorTitle: `Error de validación`,
    validationErrorDescription: `Seleccione un número SMS`,
    title: `Números SMS asociados`,
    label: `Números SMS asociados`,
    loading: `Cargando...`,
    selectPlaceholder: `Seleccione un número`,
    submitting: `Enviando...`,
    submit: `Enviar`,
    close: `Cerrar`,
  },
  pagination: {
    resultsPerPage: `Resultados por página:`,
    previousPage: `Página anterior`,
    nextPage: `Página siguiente`,
    jumpToPage: `Ir a la página {{page}}`,
    all: `Todos`,
  },
} satisfies MessagingLocale
